<template>
  <div>
    <el-table
      :data="tableList"
      :header-cell-style="{ 'background-color': '#F5F5F5', 'color': '#000000', 'font-size': 400, }"
      :cell-style="{ 'color': '#000000' }"
      @row-click = "rowClick"
      :row-class-name="tableRowClassName"
      border>
      <el-table-column
        prop="acdAreaName"
        show-overflow-tooltip
        label="名称">
      </el-table-column>
      <el-table-column
        prop="cadAreaExtent"
        show-overflow-tooltip
        label="面积(m²)">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableList: [],
      currentIndex: -1
    }
  },
  computed: {
    cadId () {
      return this.$route.query.cadId || ''
    },
    cadVersion () {
      return this.$store.state.cadVersion || ''
    }
  },
  watch: {
    cadVersion () {
      this.currentIndex = -1
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  destroyed () {
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.measure.selectYhCadAreaByList, {
        cadId: this.cadId,
        cadVersion: this.cadVersion
      }).then(res => {
        this.tableList = res || []
      })
    },
    rowClick (row) {
      const index = this.tableList.findIndex(item => item.acdAreaName === row.acdAreaName)
      if (this.currentIndex !== index) {
        this.currentIndex = index
        this.$event.$emit('setAreasActive', row.objectIds)
      } else {
        this.currentIndex = -1
        this.$event.$emit('setAreasActive', '')
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === this.currentIndex) {
        return 'active'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table__body-wrapper{
    width: 100%;
    min-height: 400px;
    max-height: calc(100vh - 160px);
    overflow-y: auto;
    cursor: pointer;
  }
  .active{
    background-color: #61A2FF;
  }
}
</style>
